import { render, staticRenderFns } from "./PayRemainder.vue?vue&type=template&id=0ef15374&"
import script from "./PayRemainder.vue?vue&type=script&lang=js&"
export * from "./PayRemainder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports